import gql from 'graphql-tag';

export const TOGGLE_FAVORITE = gql`
  mutation AlternarCursoFavorito($cursoId: String!) {
    alternarCursoFavorito(cursoId: $cursoId)
  }
`;
